import React from 'react';
import { Field, SxStyle } from '../../../../../types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import ColorPickerField from '../../../fields/color-picker-field';

const styles: SxStyle = {
  container: {
    borderBottom: '1px solid',
    borderColor: 'shades.p15',
    padding: 2,
    paddingTop: 3,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  picker: {
    minHeight: '85px',
  },
};

interface Props {
  field: Field;
  title: string;
  description: string;
  disabled?: boolean;
  setChange: (
    key: string,
    value: string | number | boolean | null,
    validation: any,
    isTeamDataValue: boolean
  ) => void;
}

const ColorItem = ({ field, title, description, disabled, setChange }: Props) => {
  return (
    <Stack
      sx={{
        ...styles.container,
        ...{ opacity: disabled ? 0.3 : 1 },
      }}
      direction="row"
      spacing={2}
    >
      <Box sx={{ ...styles.picker, ...{ pointerEvents: disabled ? 'none' : 'auto' } }}>
        <ColorPickerField field={field} isReadOnly={false} setChange={setChange} />
      </Box>
      <Box>
        <Typography variant="subtitle2">{title}</Typography>
        <Typography variant="body2">{description}</Typography>
      </Box>
    </Stack>
  );
};

export default ColorItem;
